import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Collapse } from 'antd';
const { Panel } = Collapse;
import 'antd/lib/collapse/style/css';

function Home(props) {
  const [matters,setMatters] = useState(props.matters);
  const {openAll, hightClass} = props;
  
  const changeDayMatter = () => {
    let day_first_ms = 0;
    $('.matters_container').on('mousedown', '.day-header >.ant-collapse-header', function(e) {
      day_first_ms = new Date();
    })
    $('.matters_container').on('mouseup', '.day-header >.ant-collapse-header', function(e) {
      let last_ms = new Date();
      if ( last_ms - day_first_ms < 250 && e.button == 0) {
        let itemIndex = $(this).parent().index();
        let fatherIndex = $(this).parents('.heel').index();
        let newList = matters.map((item,id) => {
          if(item.children && fatherIndex == id){
              item.children.map((ele,key) => {
                  if(itemIndex == key){
                    ele.close = !ele.close;
                  }
                  return ele;
              })
          }
          return item;
        })
        setMatters(newList);
      }
    })
  }
  const changeYearMatter = () => {
    let year_first_ms = 0;
    $('.matters_container').on('mousedown', '.heel >.ant-collapse-header', function(e) {
      year_first_ms = new Date();
    })
    $('.matters_container').on('mouseup', '.heel >.ant-collapse-header', function(e) {
      let last_ms = new Date();
      if ( last_ms - year_first_ms < 250 && e.button == 0) {
        let itemIndex = $(this).parent().index();
        let newList = matters.map((item,id) => {
          if(itemIndex == id){
            item.close = !item.close;
            if ( item.close ) {  // 如果点击之后的状态是关闭的
              item.children.map((obj, index) => {
                obj.close = true;
                return obj;
              });              // 如果点击之后的状态是打开的
            } else {
              item.children.map((obj, index) => {
                if ( index == 0 || openAll ) {
                  obj.close = false;
                  return obj
                }
                obj.close = true;
                return obj;
              });  
            }
          } 
          // 如果想要手风琴模式就释放下面 注释掉的代码
          // else {
          //   item.close = true;
          // }
          return item;
        })
        setMatters(newList);
      }
    })
  }
  const genDayExtra = (item, hasContent = true) => {
    let openStatusHtml = '';
    if(hasContent){
      openStatusHtml = <i className={`iconfont icon-open-close ${item.close ? 'icon-add-bold' : 'icon-minus-bold'}`} />;
    }else{
      openStatusHtml = <></>;
    }
    
    return (
      <div className={`matter-day-title ${!hasContent && 'matter-day-title_no-data'}`}>
        <div className="l">
            <div className="icon-calendar-wrap">
                <i className="iconfont icon-calendar" />
            </div>
            <span className="day">{item.day}</span>
        </div>
        <div className={`r ${item.close || (item.desc == '' && item.cover_img == null) ? 'close-style' : ''}`}>
          <span className={`title ${item.close ? '' : 'text-green'}`}>{item.title}</span>
          {openStatusHtml}
        </div>
      </div>
    );
  };
  const loopMatter = () => {
    return function fn(children) {
      return children.map((e, i) => {
        if (e.children) {
          return (
            <Panel header={e.year} key={i} className="heel" collapsible="disabled">
                <Collapse className="day-wrap" key={i} activeKey={
                  e.children.map((item, index) => {
                    if (item.close === false) {
                      return index + '';
                    } else {
                      return '';
                    }
                  })
                }>
                    {fn(e.children)}
                </Collapse>
            </Panel>
          );
        } else if(e.cover_img || e.desc) {
          return (
            <Panel key={i} className="" extra={genDayExtra(e)} showArrow={false} collapsible="disabled" className="day-header">
              {
                e.cover_img &&
                <div className="img-box">
                    <img src={e.cover_img} alt="" className="img"/>
                </div>
              }
              {
                e.desc &&
                <div className="text-pre-wrap matter-text-content">
                    {e.desc}
                </div>
              }
            </Panel>
          );
        }else{
            return genDayExtra(e, false);
        }
      });
    };
  };
	const resetData = () => {
		let newMatters = matters.map((item,key) => {
			if (key == 0) {
				item.close = false;
				item.children.map((ele,id) => {
					if ( id == 0 || openAll) {
						ele.close = false;
						return ele;
					}
					ele.close = true;
					return ele;
				})
			} else {
				item.close = true;
				item.children.map((ele,id) => {
					ele.close = true;
					return ele;
				})
			}
			return item;
		})
		setMatters(
			newMatters
		)
	}
  const bindTitle = () => {
    $('body').on('.memorabilia-title','click',function () {
      if($(this).hasClass(hightClass)) {
        $(this).removeClass(hightClass)
      }else{
        $(this).addClass(hightClass)
      }
    })
  }
	useEffect(() => {
		resetData();
		bindTitle();
	},[])
  useEffect(() => {
    changeDayMatter();
  },[])
  useEffect(() => {
    changeYearMatter();
  },[])
  return (
      <div className="matters-container">
          <Collapse className="year-wrap" activeKey={
            matters.map((item, index) => {
              if (item.close === false) {
                console.log("index", index);
                return index + '';
              } else {
                return '';
              }
            })
          }>
            {loopMatter()(matters)}
          </Collapse>
      </div>
      );
}
class Matters {
	constructor(options) {
		this.defaultOptions = {
			openAll: false,			// 是否第二级panel全部展开
			activeClass: '',		// 活跃的类名
		};
		this.options = Object.assign(this.defaultOptions, options);
	}
	init() {
		const domContainer = document.querySelector('.matters_container');
		ReactDOM.render(<Home {...this.options}/>, domContainer);
		if(this.options.initCb && typeof this.options.initCb === 'function')  {
			this.options.initCb();
		}
	}
}

window.Matters = Matters;
